import ReactPlayer from "react-player";
import "@styles/components/ui/VideoPlayer.scss";
import { Box, Typography, useMediaQuery } from "@mui/material";
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaVolumeRange,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaMuteButton,
  MediaFullscreenButton,
} from "media-chrome/react";

const VideoPlayer = ({ videoUrl }) => {
  const isPad = useMediaQuery("(max-width:768px)");
  const isMobile = useMediaQuery("(max-width:425px)");
  return (
    <Box className="video-player-container">
      <MediaController className="media-controller-container">
        <ReactPlayer
          slot="media"
          src={videoUrl}
          controls={isMobile? true : false}
          style={{
            width: "100%",
            height: "100%",
            "--controls": "none",
            borderRadius: "15px",
            overflow: "hidden",
            background: "transparent",
          }}
          playsInline={true}
        ></ReactPlayer> 
       {!isMobile &&
        <MediaControlBar className="media-control-bar-container">
          {!isMobile && <MediaTimeRange />}

          <Box className="media-control-bottom-container">
            <Box className="media-control-left-container">
              <Box className="media-control-play-container">
                <MediaPlayButton />
              </Box>
              {!isMobile && (
                <Box className="media-control-mute-container">
                  <MediaMuteButton />
                  <MediaVolumeRange />
                </Box>
              )}
            </Box>
            {isMobile && <MediaTimeRange />}
            <Box className="media-control-right-container">
              <Box className="media-control-time-container">
                {!isPad && (
                  <>
                    <MediaSeekBackwardButton seekOffset={10} />
                    <MediaSeekForwardButton seekOffset={10} />
                  </>
                )}
                {!isMobile && <MediaTimeDisplay showDuration />}

                {!isPad && (
                  <>
                    <MediaPlaybackRateButton />
                  </>
                )}
              </Box>
              <Box className="media-control-fullscreen-container">
                <MediaFullscreenButton />
              </Box>
            </Box>
          </Box>
        </MediaControlBar>}
      </MediaController>
    </Box>
  );
};

export default VideoPlayer;
